module.exports = __webpack_public_path__ + "img/mic_off.01da3139.svg";